import { status } from '../../helpers'

const getGroupOrderStoreDefaultState = () => {
  return {
    creatingGroupOrder: false,
    creatingGroupOrderStep: 1,
    totalGroupOrderStep: 7,
    currentGroupOrderDetails: {},
    loadProducts: status.INITIALIZED,
    groupOrderProducts: [],
    loadGroupOrder: status.INITIALIZED,
    groupOrderDetails: {},
    groupOrderTiers: [],
    tempGroupOrderTier: {},
    temporalSelectedItems: [],
    selectedTierItemsToRemove: [],
    removeMultipleTierItemsStatus: false,
    updatingGroupTierItems: false,
    tempItemToRemove: {},
    updatingGroupOrderPassword: false,
    loadGroupOrdersList: status.INITIALIZED,
    groupOrdersList: [],
    loadGroupOrderItemsOrdered: status.INITIALIZED,
    groupOrderItemsOrdered: [],
    loadGroupOrderRecipientsList: status.INITIALIZED,
    groupOrderRecipientsList: [],
    groupOrderRecipientsListExport: [],
    loadRecipientGroupOrderSelectedItems: status.INITIALIZED,
    recipientsGroupOrderSelectedItems: [],
    loadGroupOrderPublicInfo: status.INITIALIZED,
    finalizingGroupOrder: false,
    recipientsToSkipOrRemove: [],
    validatingRecipient: false,
    recipient: {},
    loadGroupOrderTiersForRecipient: status.INITIALIZED,
    selectableTiers: [],
    selectedVariants: [],
    tempItemToRemoveRecipient: {},
    tempBundleItemsToRemove: [],
    activeItemsPerTier: [],
    updatingRecipientInfo: false,
    confirmWithSuccess: false,
    isConfirming: false,
    selectedTemplateId: '',
    variantSelection: {},
    // cardMessage: ''
    paginationTotalCount: 0,
    recipientTotal: 0,
    shippingLoading: false,
    loadAllowList: false,
    allowList: [],
    removeAllUsers: false,
    allowListUploaded: false,
    verificationEmailSent: false,
    loadAllowListEcommerce: false,
    allowListEcommerce: [],
    updatingAutoFinalizing: false
  }
}

export default getGroupOrderStoreDefaultState
